export enum UnitTypeEnum {
  Size = "size",
  Weight = "weight",
  Volume = "volume",
  Area = "area",
  Other = "other",
}

export interface UnitResource {
  id: string;
  title: string;
  type: UnitTypeEnum;
}

export type UpdateUnitRequestBody = {
  title: string;
};

export type StoreUnitRequestBody = {
  title: string;
};
